export const phoneNumberFormatter = (phone, dialCode) => {
    return phone.replace(dialCode, `+${dialCode} `)
}